/**
 * Represents intents from the Answers API.
 *
 * @public
 */
export enum SearchIntent {
  /** The Answers API is requesting a prompt for the user's location. */
  NearMe = 'NEAR_ME'
}